import { render, staticRenderFns } from "./MessageTip.vue?vue&type=template&id=455261dc&scoped=true&"
import script from "./MessageTip.vue?vue&type=script&lang=js&"
export * from "./MessageTip.vue?vue&type=script&lang=js&"
import style0 from "./MessageTip.vue?vue&type=style&index=0&id=455261dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455261dc",
  null
  
)

export default component.exports